const donation = (state = 'SHOW_ALL', action) => {
  switch (action.type) {
    case 'SET_VISIBILITY_FILTER': // FIXME: real action
      return action.filter;
    default:
      return state;
  }
};

export default donation;



/** WEBPACK FOOTER **
 ** ./src/reducers/donation.js
 **/